import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const DepositsPage = lazy(() => import('./DepositsPage'));

const DepositsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Payments,
  routes: [
    {
      path: 'deposits',
      element: <DepositsPage />,
    },
  ],
};

export default DepositsConfig;
